// Nombre del cliente provisional con el que el backend (tmc-sac) sostiene una
// alerta cuyo numero entrante coincide con varios pacientes. Debe coincidir con
// CreateUnidentifiedClientAction.UNIDENTIFIED_CLIENT_NAME en tmc-sac.
export const UNIDENTIFIED_CLIENT_NAME = 'Sin identificar';

/**
 * Una alerta necesita que el operador identifique al paciente cuando el numero
 * entrante coincidio con varios pacientes. Se detecta por el estado (alarmas en
 * cola) o por el cliente provisional "Sin identificar" (tambien llamadas en
 * vivo, cuyo estado lo gestiona la telefonia).
 */
export const needsClientIdentification = (alarm: any): boolean =>
  !!alarm &&
  (alarm.state === 'PENDING_CLIENT_IDENTIFICATION' || alarm?.client?.name === UNIDENTIFIED_CLIENT_NAME);

// Número del puente Jitsi (JITSI_GATEWAY_NUMBER en tmc-sac, default '9001').
const JITSI_GATEWAY_NUMBER = '9001';

/**
 * ¿Este miembro de la conferencia representa al OPERADOR (para silenciarlo)?
 *
 * El operador aparece de dos formas según la config del proveedor en tmc-sac:
 *  - modo clásico (USE_JITSI_GATEWAY=0): con su extensión REAL y `type='OPERATOR'`.
 *  - modo gateway (USE_JITSI_GATEWAY=1): a través del puente Jitsi, con
 *    `number = JITSI_GATEWAY_NUMBER` ('9001') y `type='EXTERNAL'` (9001 no es una
 *    extensión de operador, así que tmc-sac no lo tipa como OPERATOR).
 *
 * Por eso ninguno de los dos criterios es universal por separado; usamos el OR.
 */
export const isOperatorMember = (member: any): boolean =>
  !!member && (member.type === 'OPERATOR' || String(member.number) === JITSI_GATEWAY_NUMBER);

export const findOperatorMember = (members: any[] | undefined | null): any =>
  (members ?? []).find(isOperatorMember) ?? null;
